import { LeftArrow } from "@components/atoms/Icons/components/left-arrow";
import { RightArrow } from "@components/atoms/Icons/components/right-arrow";
import { FeatuerdArticle } from "@components/molecules/featured-article/index.client";
import { EducationalPreview } from "@components/organisms/educational-preview/index.client";
import { translate } from "@locales";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Tags } from "../../../components/molecules/educational-tags/index.client";
import { BlogsHeader } from "@components/atoms/blogs-header/index.client";
import { Item } from "@models/types/item.interface";

interface props {
  itemsPerPage: number;
  items: Array<any>;
}

function useBlogs({ items }: Blogs) {
  const featuredItems = items?.filter((item: Item) =>
    item["tags"].some((innerArray: string) => innerArray.includes("newsletter"))
  );

  return {
    models: { featuredItems },
  };
}
interface Blogs {
  currentItems?: Item[];
  items?: Item[];
  blog?: Item;
}

// TO DO: DO THIS COMPONENT MORE GENERIC
function Blogs({ currentItems }: Blogs) {
  return (
    <div className="md:grid md:grid-cols-2 md:gap-x-[55px] md:gap-y-[55px]">
      {currentItems &&
        currentItems.map((item: Item) => (
          <EducationalPreview blog={item} key={item.id} />
        ))}
    </div>
  );
}

function usePagination({ itemsPerPage, items }: props) {
  const [itemOffset, setItemOffset] = useState(0);
  const [searchBytags, setSearchBytags] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setItemOffset(0);
    setCurrentPage(0);
  }, [searchBytags]);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems =
    searchBytags.length > 0
      ? searchBytags.slice(itemOffset, endOffset)
      : items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(
    searchBytags.length > 0
      ? searchBytags.length / itemsPerPage
      : items.length / itemsPerPage
  );

  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected);
  };

  function handleSectionClick(id: string): void {
    
    document.getElementById(`${id}`)?.scrollIntoView?.({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
  return {
    models: {
      currentItems,
      pageCount,
      searchBytags,
      currentPage
    },
    operations: {
      handleSectionClick,
      handlePageClick,
      setSearchBytags,
    },
  };
}

export function PaginatedBlogs({ itemsPerPage, items }: props) {
  const { models, operations } = usePagination({ itemsPerPage, items });
  const { models: useBlogsModels } = useBlogs({ items });

  const isFirstPage = models.currentPage === 0;
  const isLastPage = models.currentPage === models.pageCount - 1;
  return (
    <>
      {useBlogsModels?.featuredItems?.map((item: Item) => (
        <div key={item.id}>
          <FeatuerdArticle blog={item} />
        </div>
      ))}
      <BlogsHeader />
      <div className="pb-5">
        <Tags items={items} setSearchBytags={operations.setSearchBytags} />
      </div>
      <div className="flex flex-col md:justify-center lg:flex-row lg:flex-wrap lg:mx-32 lg:mt-[45px]">
        <Blogs currentItems={models.currentItems} items={items} />
      </div>
      <div className="py-[93px] mx-auto">
        <ReactPaginate
          previousLabel={
            <div className={`flex ${isFirstPage ? 'opacity-50 cursor-not-allowed' : ''}`}>
              <LeftArrow width="35" height="25" />
              {translate("base.backward-page")}
            </div>
          }
          nextLabel={
            <div className={`flex font-chivo-regular ${isLastPage ? 'opacity-50 cursor-not-allowed' : ''}`}>
              {translate("base.next-page")}
              <RightArrow width="35" height="25" />
            </div>
          }
          pageCount={models.pageCount}
          pageRangeDisplayed={3}
          marginPagesDisplayed={0}
          onPageChange={operations.handlePageClick}
          containerClassName={"flex justify-center items-center space-x-1"}
          pageClassName={
            "px-4 py-2 text-gray-700 hover:underline underline-offset-4"
          }
          pageLinkClassName={"page-link"}
          previousClassName={`page-item ${isFirstPage ? 'pointer-events-none' : ''}`}
          previousLinkClassName={"page-link"}
          nextClassName={`page-item ${isLastPage ? 'pointer-events-none' : ''}`}
          nextLinkClassName={"page-link"}
          activeClassName={"underline underline-offset-4"}
          breakLabel={null}
          onClick={() =>  operations.handleSectionClick("EducationalTop")}
        />
      </div>
    </>
  );

}
